import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'

import FacebookPages from './FacebookPages'
import TikTokIdentities from './TikTokIdentities'

import {
  selectedFacebookAdAccountSelector,
  selectedTikTokAdAccountSelector
} from '../../../modules/selectors/adAccounts'
import { selectedPartnershipIdSelector, selectedPartnershipSelector } from '../../../modules/selectors/partnerships'
import { clearAccessibleSocialPages, getAccessibleSocialPages } from '../../../modules/actions/socialAccounts'

import useCommonStyles from '../../../styles/common/listPage'

const PagesAndIdentities = () => {
  const dispatch = useDispatch()
  const commonClasses = useCommonStyles()

  const { t } = useTranslation()

  const { id: facebookAdAccountId } = useSelector(selectedFacebookAdAccountSelector)
  const { id: tikTokAdAccountId } = useSelector(selectedTikTokAdAccountSelector)
  const { name: partnershipName } = useSelector(selectedPartnershipSelector)
  const selectedPartnershipId = useSelector(selectedPartnershipIdSelector)

  const isFacebookOrTiktok = !!facebookAdAccountId || !!tikTokAdAccountId

  useEffect(() => {
    if (isFacebookOrTiktok) {
      // trigger GET on partnership change(keep this in the dependency array),
      // don't filter by platform - fetch all for both lists
      dispatch(getAccessibleSocialPages())
    }
  }, [dispatch, isFacebookOrTiktok, selectedPartnershipId])

  useEffect(() => {
    return () => {
      dispatch(clearAccessibleSocialPages())
    }
  }, [dispatch])

  return (
    <>
      <h2 className={commonClasses.title}>{t(`Pages and Identities for ${partnershipName}`)}</h2>
      {facebookAdAccountId && <FacebookPages />}
      {tikTokAdAccountId && <TikTokIdentities />}
    </>
  )
}

export default PagesAndIdentities
